import {DEFAULT_TIME_ZONE} from '../utils'

import {usePlantContext} from './usePlantContext'

export const useTimeZone = () => {
  const {data} = usePlantContext()
  const timezone = data?.timezone ?? DEFAULT_TIME_ZONE
  return timezone
}
